<script setup>
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 226 155">
        <path
            d="M81 5C76.0294 5 72 9.02944 72 14V26H59C42.4315 26 29 39.4315 29 56V71H49.5C65.2401 71 78 83.7599 78 99.5C78 108.391 73.9305 116.331 67.5557 121.572H98V130H128V121.572H158.444C152.069 116.331 148 108.391 148 99.5C148 83.7599 160.76 71 176.5 71H197V56C197 39.4315 183.569 26 167 26H154V14C154 9.02944 149.971 5 145 5C140.029 5 136 9.02944 136 14V26H90V14C90 9.02944 85.9706 5 81 5Z" />
        <path
            d="M47.5 80C57.165 80 65 87.835 65 97.5C65 107.165 57.165 115 47.5 115C37.835 115 30 107.165 30 97.5C30 87.835 37.835 80 47.5 80Z" />
        <path
            d="M178.5 80C188.165 80 196 87.835 196 97.5C196 107.165 188.165 115 178.5 115C168.835 115 161 107.165 161 97.5C161 87.835 168.835 80 178.5 80Z" />
        <path d="M27 117H68C80.7025 117 91 127.297 91 140V150H4V140C4 127.297 14.2975 117 27 117Z" />
        <path d="M158 117H199C211.703 117 222 127.297 222 140V150H135V140C135 127.297 145.297 117 158 117Z" />
    </svg>
</template>

<style lang="scss" scoped></style>
